import { up, down } from 'slide-element';
import announcer from './aria-announcer';

document.addEventListener('DOMContentLoaded', () => {
    const $searchSortings = document.querySelectorAll('.search-sorting');
    if (!$searchSortings.length) return;

    $searchSortings.forEach((searchSorting) => {
        const $button = searchSorting.querySelector('.btn-sorting');
        const $menu = searchSorting.querySelector('.sorting-panel');
        const $span = $button.querySelector('span');

        if (!$button || !$menu || !$span) return;

        $menu.style.display = 'none';
        $button.setAttribute('aria-expanded', 'false');
        $menu.setAttribute('aria-hidden', 'true');

        const savedFilter = localStorage.getItem('selectedFilter');
        if (savedFilter) {
            $span.textContent = savedFilter;
        }

        $button.addEventListener('click', () => {
            const expanded = $button.getAttribute('aria-expanded') === 'true';

            if (expanded) {
                $button.setAttribute('aria-expanded', 'false');
                $menu.setAttribute('aria-hidden', 'true');
                up($menu);
                announcer.announce('Filtres fermé');
            } else {
                $button.setAttribute('aria-expanded', 'true');
                $menu.setAttribute('aria-hidden', 'false');
                down($menu);
                announcer.announce('Filtres ouvert');
            }
        });

        $menu.querySelectorAll('a').forEach((link) => {
            link.addEventListener('click', () => {
                const filterText = link.textContent;
                $span.textContent = filterText;
                localStorage.setItem('selectedFilter', filterText);
                announcer.announce(`Filtre sélectionné : ${filterText}`);
                up($menu);
                $button.setAttribute('aria-expanded', 'false');
                $menu.setAttribute('aria-hidden', 'true');
            });
        });
    });
});
